import { gql } from "@apollo/client";

export const GET_ROLES_QUERY = gql`
  query PaginatedCandidateRoles(
    $offset: Int
    $limit: Int
    $search: String
    $certifications: [String]
    $skills: [String]
  ) {
    paginatedCandidateRoles(offset: $offset, limit: $limit, search: $search, certifications: $certifications, skills: $skills) {
      roles {
        id
        name
        category
        subCategory
        certifications
        skills
      }
      total
      limit
      offset
    }
  }
`;

export const ALL_SKILLS_QUERY = gql`
  query AllSkills {
    allSkills {
      id
      name
    }
  }
`;

export const ALL_CERTIFICATIONS_QUERY = gql`
  query AllCertifications {
    allCertifications {
      id
      name
    }
  }
`;

export const EDIT_ROLE_ALL_QUERY = gql`
  query EditRoleAll($id: ID!) {
    getCandidateRole(id: $id) {
      id
      name
      category
      subCategory
      certificationIds
      skillIds
    }
    allCertifications {
      id
      name
    }
    allSkills {
      id
      name
    }
  }
`;

export const NEW_ROLE_ALL_QUERY = gql`
  query NewRoleAll {
    allCertifications {
      id
      name
    }
    allSkills {
      id
      name
    }
  }
`;

export const UPSERT_ROLE_MUTATION = gql`
  mutation UpsertCandidateRole(
    $id: ID
    $name: String!
    $category: String!
    $subCategory: String
    $certificationIds: [ID!]
    $skillIds: [ID!]
  ) {
    upsertCandidateRole(
      id: $id
      name: $name
      category: $category
      subCategory: $subCategory
      certificationIds: $certificationIds
      skillIds: $skillIds
    ) {
      id
      name
      category
      subCategory
      certificationIds
      skillIds
    }
  }
`;

export const UPSERT_SKILL_MUTATION = gql`
  mutation UpsertSkill(
    $id: ID
    $name: String!
  ) {
    upsertSkill(
      id: $id
      name: $name
    ) {
      id
      name
    }
  }
`;


export const UPSERT_CERTIFICATION_MUTATION = gql`
  mutation UpsertCertification(
    $id: ID
    $name: String!
  ) {
    upsertCertification(
      id: $id
      name: $name
    ) {
      id
      name
    }
  }
`;